import { useApiStore } from './api.ts'
import { defineStore } from 'pinia'

export const useEnfantStore = defineStore('enfant', {
  state: () => ({
    api: useApiStore(),
    enfants: null,
    nouveauEnfant: {
      nom: '',
      prenom: '',
      date_de_naissance: null,
    },
  }),
  actions: {
    async getEnfants () {
      const enfantsData = await this.api.get(`/enfants/`)
      this.enfants = enfantsData.data
    },
    async sauvegardeEnfant () {
      const enfantData = await this.api.post(`/enfants/`, this.nouveauEnfant)
      this.getEnfants();
    },
  }
})